<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="10">
            <h3>صفحة اقساط الاقسام</h3>
          </v-col>
          <v-col cols="2" align="left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" fab small color="primary" @click="exportExcel" v-bind="attrs" v-on="on">
                  <v-icon dark> mdi-microsoft-excel </v-icon>
                </v-btn>
              </template>
              <span>تصدير</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-card-title>
          <v-text-field v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="sectionLevels" :items-per-page="15" :search="search" item-key="idStudent" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>

          <template v-slot:[`item.level`]="{ item }">
            <p style="padding: 0 3px">{{ item.sectionLevel | setLevel }}</p>
          </template>

          <template v-slot:[`item.students`]="{ item }">
            <p style="padding: 0 3px">
              {{ item.studentCount || 0 }}
            </p>
          </template>

          <template v-slot:[`item.totalAmount`]="{ item }">
            <p style="padding: 0 3px">
              {{ (item.totalAmount || 0).toLocaleString("en-US") }}
            </p>
          </template>

          <template v-slot:[`item.PaidAmount`]="{ item }">
            <p style="padding: 0 3px">
              {{ (item.paidAmount || 0).toLocaleString("en-US") }}
            </p>
          </template>

          <template v-slot:[`item.percentage`]="{ item }">
            <p style="padding: 0 3px">
              {{ (item.percentage || 0).toFixed(2) }}%
            </p>
          </template>

          <template v-slot:[`item.RemainAmount`]="{ item }">
            <p style="padding: 0 3px">
              {{ (item.remainingAmount || 0).toLocaleString("en-US") }}
            </p>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AddSectionCost from "../components/AddSectionCost.vue";
import EditSectionInstallments from "../components/EditSectionInstallments.vue";
const Excel = require("exceljs");
export default {
  components: {
    AddSectionCost,
    EditSectionInstallments,
  },
  data: () => ({
    search: "",
    overlay: false,
    selected: [],
    sectionLevels: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "القسم", value: "sectionName" },
      { text: "المرحلة", value: "level" },
      { text: "عدد الطلبة", value: "students" },
      { text: "القسط الكلي", value: "totalAmount" },
      { text: "القسط المدفوع", value: "PaidAmount" },
      { text: "القسط المتبقي", value: "RemainAmount" },
      { text: "النسبة", value: "percentage" },
    ],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;
      self.overlay = true;
      self.$http
        .get(`${self.$store.state.apiUrlRegistration}/v2/getAllStudentSectionStatistics`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);
          let levelsForSections = self.$store.state.sections.map((section) => {
            if (section.idSection == 7) {
              let sectionL = [
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 1 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 2 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 3 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 4 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 5 },
              ];

              return [...sectionL];
            } else {
              let sectionR = [
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 1 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 2 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 3 },
                { idSection: section.idSection, sectionName: section.sectionName, sectionLevel: 4 },
              ];

              return [...sectionR];
            }
          });
          // Backend now returns aggregated data directly
          // Format: [{sectionId, sectionName, level, studentCount, totalAmount, paidAmount, remainingAmount, percentage}, ...]
          let aggregatedData = res.data || [];
          
          // Map backend data to frontend format
          self.sectionLevels = aggregatedData.map((item) => ({
            idSection: item.sectionId,
            sectionName: item.sectionName,
            sectionLevel: item.level,
            studentCount: item.studentCount || 0,
            totalAmount: item.totalAmount || 0,
            paidAmount: item.paidAmount || 0,
            remainingAmount: item.remainingAmount || 0,
            percentage: item.percentage || 0
          }));

          //   let sectionLevelOne = self.$store.state.sections.map((section) => {
          //     let totalAmountSectionOne = res.data.studentAmount.filter((student) => student.level == 1 && student.sectionId == section.idSection);
          //     return { [section.sectionName]: totalAmountSectionOne, sectionId: section.idSection };
          //   });

          //   let sectionLevelTwo = self.$store.state.sections.map((section) => {
          //     let totalAmountSectionOne = res.data.studentAmount.filter((student) => student.level == 2 && student.sectionId == section.idSection);
          //     return { [section.sectionName]: totalAmountSectionOne, sectionId: section.idSection };
          //   });

          //   let sectionLevelThree = self.$store.state.sections.map((section) => {
          //     let totalAmountSectionOne = res.data.studentAmount.filter((student) => student.level == 3 && student.sectionId == section.idSection);
          //     return { [section.sectionName]: totalAmountSectionOne, sectionId: section.idSection };
          //   });

          //   let sectionLevelFour = self.$store.state.sections.map((section) => {
          //     let totalAmountSectionOne = res.data.studentAmount.filter((student) => student.level == 4 && student.sectionId == section.idSection);
          //     return { [section.sectionName]: totalAmountSectionOne, sectionId: section.idSection };
          //   });

          //   let sectionLevelFive = self.$store.state.sections.map((section) => {
          //     let totalAmountSectionOne = res.data.studentAmount.filter((student) => student.level == 5 && student.sectionId == section.idSection);
          //     return { [section.sectionName]: totalAmountSectionOne, sectionId: section.idSection };
          //   });
          self.overlay = false;
        })
        .catch((e) => {
          console.log(e);
          self.overlay = false;
          this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
        });
    },
    selectStudent(student) {
      console.log(student);
    },
    getStudentLevelBySection(section) {
      // Data is now pre-aggregated from backend
      return section.totalAmount || 0;
    },

    getStudentLevelBySectionCount(section) {
      // Data is now pre-aggregated from backend
      return section.studentCount || 0;
    },

    getPaidStudentLevelBySection(section) {
      // Data is now pre-aggregated from backend
      return section.paidAmount || 0;
    },

    exportExcel() {
      let self = this;
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("احصائيات الاقسام المالية");

      worksheet.columns = [
        { header: "القسم", key: "sectionName", width: 50 },
        { header: "المرحلة", key: "level", width: 50 },
        { header: "عدد الطلبة", key: "students", width: 20 },
        { header: "القسط الكلي", key: "totalAmount", width: 50 },
        { header: "القسط المدفوع", key: "PaidAmount", width: 50 },
        { header: "القسط المتبقي", key: "RemainAmount", width: 50 },
        { header: "النسبة", key: "percentage", width: 50 },
      ];

      self.sectionLevels.forEach((section) => {
        worksheet.addRow({
          sectionName: section.sectionName,
          level: self.$options.filters.setLevel(section.sectionLevel),
          students: section.studentCount || 0,
          totalAmount: section.totalAmount || 0,
          PaidAmount: section.paidAmount || 0,
          RemainAmount: section.remainingAmount || 0,
          percentage: `${(section.percentage || 0).toFixed(2)}%`,
        });
      });

      worksheet.eachRow(function (row, rowNumber) {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "darkTrellis",
          fgColor: { argb: "FFFFFF00" },
          bgColor: { argb: "FF0000FF" },
        };
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        a.download = `sectionPayments.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    },
  },
  filters: {
    setLevel: function (level) {
      if (level == 1) {
        return "المرحلة الاولى";
      } else if (level == 2) {
        return "المرحلة الثانية";
      } else if (level == 3) {
        return "المرحلة الثالثة";
      } else if (level == 4) {
        return "المرحلة الرابعة";
      } else if (level == 5) {
        return "المرحلة الخامسة";
      }
    },
    setStudyType: function (studyType) {
      if (studyType == 1) {
        return "صباحي";
      } else {
        return "مسائي";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
